import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "job_wrapper" }

import JobListTableComponent from "../components/JobListTableComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'jobPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(JobListTableComponent)
  ]))
}
}

})